import { render, staticRenderFns } from "./ajout-type.html?vue&type=template&id=65b3aef5&scoped=true&external"
import script from "./ajout-type.js?vue&type=script&lang=js&external"
export * from "./ajout-type.js?vue&type=script&lang=js&external"
import style0 from "./ajout-type.scss?vue&type=style&index=0&id=65b3aef5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3aef5",
  null
  
)

export default component.exports